import { css } from '@emotion/css';

export const filterPaperStyles = css`
  width: 29.4rem;
`;
